export const load = () => ({
	title: 'Ways to Save with Energy Efficiency in Your Home',
	showTitle: true,
});
